(function () {
  'use strict';

  var LOG_PREFIX = '[CartLimitMsg]';

  try {
    // Không chạy 2 lần nếu snippet bị nhúng trùng
    if (window.__cartLimitMsgInit) return;
    window.__cartLimitMsgInit = true;

    // Các phần tử có thể chứa câu báo lỗi (trang cart và cart drawer)
    var SELECTORS = '.cart-item__error-text, [id^="LineItemError"], .cart-item__error';

    // Bắt câu: "You can't add more 1 Leukoplast CADOU! to the cart."
    // Nhóm 1 = số lượng (có thể không có), nhóm 2 = tên sản phẩm
    var PATTERN = /You\s+can(?:'|’|‘)?t\s+add\s+more\s+(?:(\d+)\s+)?([\s\S]+?)\s+to\s+the\s+cart\.?/i;

    // Chọn đúng dạng số nhiều trong tiếng Romania: 1 bucată / 2–19 bucăți / 20+ de bucăți
    function getUnit(n) {
      try {
        if (n === 1) return 'bucată';
        var r = n % 100;
        if (n >= 20 && (r === 0 || r >= 20)) return 'de bucăți';
        return 'bucăți';
      } catch (e) {
        console.warn(LOG_PREFIX, 'getUnit error:', e);
        return 'bucată';
      }
    }

    function buildMessage(qty, name) {
      try {
        var n = parseInt(qty, 10);
        if (isNaN(n) || n < 1) n = 1;
        // Bỏ "!" / "." / khoảng trắng ở cuối tên để không bị "CADOU!!"
        var cleanName = String(name || '').trim().replace(/[!.\s]+$/, '');
        return 'Poți adăuga în coș maximum ' + n + ' ' + getUnit(n) + ' din produsul ' + cleanName + '!';
      } catch (e) {
        console.warn(LOG_PREFIX, 'buildMessage error:', e);
        return null;
      }
    }

    // Thay trong từng text node (giữ nguyên icon svg và các thẻ bên cạnh)
    function translateTextNode(textNode) {
      try {
        var text = textNode.nodeValue;
        if (!text || !PATTERN.test(text)) return;

        var newText = text.replace(PATTERN, function (_match, qty, name) {
          var msg = buildMessage(qty, name);
          return msg === null ? _match : msg;
        });

        if (newText !== text) textNode.nodeValue = newText;
      } catch (e) {
        console.warn(LOG_PREFIX, 'translateTextNode error:', e);
      }
    }

    function translateAll() {
      try {
        var containers = document.querySelectorAll(SELECTORS);
        for (var i = 0; i < containers.length; i++) {
          try {
            var walker = document.createTreeWalker(containers[i], NodeFilter.SHOW_TEXT, null, false);
            var node;
            while ((node = walker.nextNode())) {
              translateTextNode(node);
            }
          } catch (innerErr) {
            console.warn(LOG_PREFIX, 'container scan error:', innerErr);
          }
        }
      } catch (e) {
        console.warn(LOG_PREFIX, 'translateAll error:', e);
      }
    }

    // gộp các mutation lại, mỗi frame chỉ quét 1 lần
    var scheduled = false;
    function scheduleTranslate() {
      try {
        if (scheduled) return;
        scheduled = true;
        var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
        raf(function () {
          scheduled = false;
          translateAll();
        });
      } catch (e) {
        scheduled = false;
        console.warn(LOG_PREFIX, 'scheduleTranslate error:', e);
      }
    }

    function init() {
      try {
        translateAll();

        if (!('MutationObserver' in window) || !document.body) return;

        // Câu báo lỗi được render lại sau mỗi lần cập nhật giỏ (AJAX / Alpine),
        // nên phải theo dõi DOM liên tục
        var observer = new MutationObserver(function () {
          try {
            scheduleTranslate();
          } catch (e) {
            console.warn(LOG_PREFIX, 'observer callback error:', e);
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true
        });
      } catch (e) {
        console.warn(LOG_PREFIX, 'init error:', e);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  } catch (e) {
    console.warn(LOG_PREFIX, 'fatal error:', e);
  }
})();
